import { Injectable, signal } from '@angular/core';

import { LoadQuote } from '@ph-shopping/model/cart';

@Injectable({ providedIn: 'root' })
export class QuoteContainerService {
  quote = signal<LoadQuote | null>(null);

  setQuote(value: LoadQuote) {
    this.quote.set(value);
  }
}
